import ec2Overview from './overview.json';
import ec2OverviewEditable from './overviewEditable.json';
import ec2OverviewEditableLayout from './overviewEditableLayout.json';

import summaryEC2Region from './widgets/summaryEC2Region.json';
import summaryEC2InstanceType from './widgets/summaryEC2InstanceType.json';
import summaryEC2Health from './widgets/summaryEC2Health.json';
import summaryEC2OperatingState from './widgets/summaryEC2OperatingState.json';

import ec2CPUOverview from './widgets/cpu/ec2CPUOverview.json';
import ec2CPUMaster from './widgets/cpu/ec2CPUMaster.json';
import ec2CPUDetail from './widgets/cpu/ec2CPUDetail.json';
import ec2CPUDetailTitle from './widgets/cpu/ec2CPUDetailTitle.json';
import ec2EntityCPU from './widgets/cpu/ec2CPU.json';
import ec2EntityCPUUtilization from './widgets/cpu/ec2CPUUtilization.json';
import ec2EntityCPULoadAverage from './widgets/cpu/ec2CPULoadAverage.json';
import ec2EntityCPUCredits from './widgets/cpu/ec2CPUCredits.json';

import ec2MemoryOverview from './widgets/memory/ec2MemoryOverview.json';
import ec2MemoryMaster from './widgets/memory/ec2MemoryMaster.json';
import ec2MemoryDetail from './widgets/memory/ec2MemoryDetail.json';
import ec2MemoryDetailTitle from './widgets/memory/ec2MemoryDetailTitle.json';
import ec2EntityMemoryUtilization from './widgets/memory/ec2MemoryUtilization.json';
import ec2EntityMemoryPaging from './widgets/memory/ec2MemoryPaging.json';
import ec2EntityMemorySwap from './widgets/memory/ec2MemorySwap.json';

import ec2NetworkOverview from './widgets/network/ec2NetworkOverview.json';
import ec2NetworkMaster from './widgets/network/ec2NetworkMaster.json';
import ec2NetworkDetail from './widgets/network/ec2NetworkDetail.json';
import ec2NetworkDetailTitle from './widgets/network/ec2NetworkDetailTitle.json';
import ec2NetworkPackets from './widgets/network/ec2NetworkPackets.json';
import ec2NetworkThroughput from './widgets/network/ec2NetworkThroughput.json';
import ec2NetworkPacketsDropped from './widgets/network/ec2NetworkPacketsDropped.json';

import ec2DiskOverview from './widgets/disk/ec2DiskOverview.json';
import ec2DiskMaster from './widgets/disk/ec2DiskMaster.json';
import ec2DiskDetail from './widgets/disk/ec2DiskDetail.json';
import ec2DiskDetailTitle from './widgets/disk/ec2DiskDetailTitle.json';
import ec2DiskOperations from './widgets/disk/ec2DiskOperations.json';
import ec2DiskIO from './widgets/disk/ec2DiskIO.json';

import filterEC2OperatingState from './widgets/filterEC2OperatingState.json';
import filterEC2Health from './widgets/filterEC2Health.json';
import filterEC2Region from './widgets/filterEC2Region.json';
import filterEC2InstanceType from './widgets/filterEC2InstanceType.json';

export default [
  ec2Overview,
  ec2OverviewEditable,
  ec2OverviewEditableLayout,

  // Filters
  filterEC2OperatingState,
  filterEC2Health,
  filterEC2Region,
  filterEC2InstanceType,

  // Widgets

  // summary
  summaryEC2Region,
  summaryEC2InstanceType,
  summaryEC2Health,
  summaryEC2OperatingState,

  // CPU card
  ec2CPUOverview,
  ec2CPUMaster,
  ec2CPUDetail,
  ec2CPUDetailTitle,
  ec2EntityCPU,
  ec2EntityCPUUtilization,
  ec2EntityCPULoadAverage,
  ec2EntityCPUCredits,

  // Memory Card
  ec2MemoryOverview,
  ec2MemoryMaster,
  ec2MemoryDetail,
  ec2MemoryDetailTitle,
  ec2EntityMemoryUtilization,
  ec2EntityMemoryPaging,
  ec2EntityMemorySwap,

  // Network Card
  ec2NetworkOverview,
  ec2NetworkMaster,
  ec2NetworkDetail,
  ec2NetworkDetailTitle,
  ec2NetworkPackets,
  ec2NetworkPacketsDropped,
  ec2NetworkThroughput,

  // Disk Card
  ec2DiskOverview,
  ec2DiskMaster,
  ec2DiskDetail,
  ec2DiskDetailTitle,
  ec2DiskOperations,
  ec2DiskIO,
];
